import type { MouseEvent } from 'react';
import { Maximize, Minimize } from 'lucide-react';

import { Button } from '@/components/Button/Button';
import { Tooltip } from '@/components/Tooltip/Tooltip';

import styles from './ControlBar.module.css';

interface FullscreenButtonProps {
  isFullscreen: boolean;
  onToggle: (trigger: HTMLElement | null) => void;
}

export function FullscreenButton({
  isFullscreen,
  onToggle,
}: FullscreenButtonProps) {
  const label = isFullscreen ? 'Exit fullscreen' : 'Fullscreen';
  const Icon = isFullscreen ? Minimize : Maximize;

  return (
    <Tooltip content={label}>
      <Button
        aria-label={label}
        className={styles.iconButton}
        iconOnly
        onClick={(event: MouseEvent<HTMLElement>) => {
          onToggle(event.currentTarget as HTMLElement | null);
        }}
        size="small"
        variant="ghost"
      >
        <Icon aria-hidden="true" className={styles.controlIcon} size={20} />
      </Button>
    </Tooltip>
  );
}
